
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#plus_0c710d4c4bc90d81__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 28C8 15.85 17.85 6 30 6s22 9.85 22 22-9.85 22-22 22S8 40.15 8 28Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 21.5a1 1 0 0 1 1 1V27h4.5a1 1 0 1 1 0 2H31v4.5a1 1 0 1 1-2 0V29h-4.5a1 1 0 1 1 0-2H29v-4.5a1 1 0 0 1 1-1Z",
  fill: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 21.5V21v.5Zm1 1h.5-.5Zm0 4.5h-.5v.5h.5V27Zm4.5 0v-.5.5Zm1 1h.5-.5Zm-1 1v.5-.5ZM31 29v-.5h-.5v.5h.5Zm0 4.5h.5-.5Zm-1 1v.5-.5Zm-1-1h-.5.5Zm0-4.5h.5v-.5H29v.5Zm-4.5 0v.5-.5Zm-1-1H23h.5Zm1-1v-.5.5Zm4.5 0v.5h.5V27H29Zm0-4.5h-.5.5Zm1-1v.5a.5.5 0 0 1 .5.5h1A1.5 1.5 0 0 0 30 21v.5Zm1 1h-.5V27h1v-4.5H31Zm0 4.5v.5h4.5v-1H31v.5Zm4.5 0v.5a.5.5 0 0 1 .5.5h1a1.5 1.5 0 0 0-1.5-1.5v.5Zm1 1H36a.5.5 0 0 1-.5.5v1A1.5 1.5 0 0 0 37 28h-.5Zm-1 1v-.5H31v1h4.5V29ZM31 29h-.5v4.5h1V29H31Zm0 4.5h-.5a.5.5 0 0 1-.5.5v1a1.5 1.5 0 0 0 1.5-1.5H31Zm-1 1V34a.5.5 0 0 1-.5-.5h-1A1.5 1.5 0 0 0 30 35v-.5Zm-1-1h.5V29h-1v4.5h.5Zm0-4.5v-.5h-4.5v1H29V29Zm-4.5 0v-.5a.5.5 0 0 1-.5-.5h-1a1.5 1.5 0 0 0 1.5 1.5V29Zm-1-1h.5a.5.5 0 0 1 .5-.5v-1A1.5 1.5 0 0 0 23 28h.5Zm1-1v.5H29v-1h-4.5v.5Zm4.5 0h.5v-4.5h-1V27h.5Zm0-4.5h.5a.5.5 0 0 1 .5-.5v-1a1.5 1.5 0 0 0-1.5 1.5h.5Z",
  fill: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "plus_0c710d4c4bc90d81__a",
  x: 0,
  y: 0,
  width: 60,
  height: 60,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.505882 0 0 0 0 0.054902 0 0 0 0 0.662745 0 0 0 0.17 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_17499_11172"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_17499_11172",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_17499_11172)\">\r\n<path d=\"M8 28C8 15.8497 17.8497 6 30 6C42.1503 6 52 15.8497 52 28C52 40.1503 42.1503 50 30 50C17.8497 50 8 40.1503 8 28Z\" fill=\"white\"/>\r\n<path d=\"M30 21.5C30.5523 21.5 31 21.9477 31 22.5V27H35.5C36.0523 27 36.5 27.4477 36.5 28C36.5 28.5523 36.0523 29 35.5 29H31V33.5C31 34.0523 30.5523 34.5 30 34.5C29.4477 34.5 29 34.0523 29 33.5V29H24.5C23.9477 29 23.5 28.5523 23.5 28C23.5 27.4477 23.9477 27 24.5 27H29V22.5C29 21.9477 29.4477 21.5 30 21.5Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M30 21.5V21V21.5ZM31 22.5H31.5H31ZM31 27H30.5V27.5H31V27ZM35.5 27V26.5V27ZM36.5 28H37H36.5ZM35.5 29V29.5V29ZM31 29V28.5H30.5V29H31ZM31 33.5H31.5H31ZM30 34.5V35V34.5ZM29 33.5H28.5H29ZM29 29H29.5V28.5H29V29ZM24.5 29L24.5 29.5H24.5V29ZM23.5 28H23V28L23.5 28ZM24.5 27V26.5H24.5L24.5 27ZM29 27V27.5H29.5V27H29ZM29 22.5H28.5H29ZM30 21.5V22C30.2761 22 30.5 22.2239 30.5 22.5H31H31.5C31.5 21.6716 30.8284 21 30 21V21.5ZM31 22.5H30.5V27H31H31.5V22.5H31ZM31 27V27.5H35.5V27V26.5H31V27ZM35.5 27V27.5C35.7761 27.5 36 27.7239 36 28H36.5H37C37 27.1716 36.3284 26.5 35.5 26.5V27ZM36.5 28H36C36 28.2761 35.7761 28.5 35.5 28.5V29V29.5C36.3284 29.5 37 28.8284 37 28H36.5ZM35.5 29V28.5H31V29V29.5H35.5V29ZM31 29H30.5V33.5H31H31.5V29H31ZM31 33.5H30.5C30.5 33.7761 30.2761 34 30 34V34.5V35C30.8284 35 31.5 34.3284 31.5 33.5H31ZM30 34.5V34C29.7239 34 29.5 33.7761 29.5 33.5H29H28.5C28.5 34.3284 29.1716 35 30 35V34.5ZM29 33.5H29.5V29H29H28.5V33.5H29ZM29 29V28.5H24.5V29V29.5H29V29ZM24.5 29V28.5C24.2239 28.5 24 28.2761 24 28L23.5 28L23 28C23 28.8284 23.6716 29.5 24.5 29.5L24.5 29ZM23.5 28H24C24 27.7239 24.2239 27.5 24.5 27.5V27L24.5 26.5C23.6716 26.5 23 27.1716 23 28H23.5ZM24.5 27V27.5H29V27V26.5H24.5V27ZM29 27H29.5V22.5H29H28.5V27H29ZM29 22.5H29.5C29.5 22.2239 29.7239 22 30 22V21.5V21C29.1716 21 28.5 21.6716 28.5 22.5H29Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_17499_11172\" x=\"0\" y=\"0\" width=\"60\" height=\"60\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"2\"/>\r\n<feGaussianBlur stdDeviation=\"4\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.505882 0 0 0 0 0.054902 0 0 0 0 0.662745 0 0 0 0.17 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_17499_11172\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_17499_11172\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/plus.0c710d4c4bc90d81e1caf73f798a2d6c.svg"),
        {
          React: SvgPlus,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      